import { WebPushContentDefinition } from 'modules/graphql/types';
import { FormField } from 'ui/formField';

import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { useErrorValidationContext } from '../../context/ErrorValidationContext';
import { UrlInputField } from '../../common/components';
import { displayContent } from '../../common/content';
import { FieldNames, MediumDataKey } from '../../common/types';
import { constructFieldErrors } from '../../common';
import { constructErrorInlineText } from '../../common/ErrorInlineText';

export const WEB_PUSH_ICON: MediumDataKey = 'icon';

export const displayIconContent = {
  label: 'Icon',
};

export const WebPushIconField = () => {
  const { liveTemplate, setCurrentMediumField, isEditMode } = useEditableFieldsContext();
  const { localeContentErrors, localeContentWarnings } = useErrorValidationContext();
  const webPushData = (liveTemplate?.mediumData ?? {}) as WebPushContentDefinition;

  const { hasError: hasWebPushIconError } = constructFieldErrors({
    contentErrors: localeContentErrors,
    contentWarnings: localeContentWarnings,
    fieldName: FieldNames.ICON,
  });
  const webPushIconErrorText = constructErrorInlineText({
    hasError: hasWebPushIconError,
    condition: isEditMode,
  });

  return (
    <FormField
      data-test="web-push-icon-field"
      isHorizontalLayout
      labelText={displayIconContent.label}
      hasError={hasWebPushIconError}
      errorText={webPushIconErrorText}
    >
      <UrlInputField
        hasError={hasWebPushIconError}
        id={WEB_PUSH_ICON}
        inputValue={webPushData.icon ?? ''}
        onChangeHandler={(iconUrl) => setCurrentMediumField(WEB_PUSH_ICON, iconUrl)}
        placeholderText={displayContent.placeholderIconUrl}
        mediumDataKey={WEB_PUSH_ICON}
      />
    </FormField>
  );
};
